import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOldJoystick: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconOldJoystick"><Path d="M12 3C13.933 3 15.5 4.567 15.5 6.5C15.5 8.17545 14.3224 9.57452 12.75 9.91797V14H16.5V11H18V14H21V21H3V14H11.25V9.91797C9.67756 9.57452 8.5 8.17545 8.5 6.5C8.5 4.567 10.067 3 12 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOldJoystick;
